/* eslint-disable max-len */
import React from 'react'
import { motion } from "framer-motion";
import { useSelector } from 'react-redux';


const AnimatedDeviceList = ({ child, keyItem ,id,rowStatus,handleClick,cursorpointer}) => {
    
    const selectedId=useSelector((state)=>state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    
    const selectedRows=selectedId.map((item)=>item?.id)
    return (
        <motion.tr
            key={keyItem}
            id= "list-items"
            onClick={(e)=>{
                if(handleClick){
                    handleClick(e)
                }
            }}
            // initial={{ opacity: 0, y: 20 }}
            // animate={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.3, delay: keyItem * 0.1 }}
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 0 }}
            exit={{ opacity: 0, x: 0}}   
            transition={{ duration: 0.15 }}
            className={`${selectedRows.includes(id)?"bg-[#F8EEF1]":"bg-[#FFFFFF]"} rounded-[2px] hover:bg-[#F8EEF1] table-tr  ${cursorpointer ? 'cursor-pointer' : ''}`}
        >
            {child}
        </motion.tr>
    );
}

export default AnimatedDeviceList;